<template>
  <q-table
    :rows="rows"
    :columns="columns"
    :row-key="rowKey"
    :loading="loading"
    :pagination="pagination"
    @row-click="onRowClick"
  >
    <template
      v-for="(_, slotName) in $slots"
      #[slotName]="slotProps"
    >
      <slot :name="slotName" v-bind="slotProps || {}" />
    </template>
  </q-table>
</template>

<script>
export default {
  name: 'DataTable',
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    rowKey: {
      type: String,
      default: 'id'
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: () => ({ rowsPerPage: 10 })
    }
  },
  emits: ['row-click'],
  methods: {
    onRowClick(evt, row) {
      this.$emit('row-click', { evt, row })
    }
  }
}
</script>
